var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"area","height":"260","options":_vm.options,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }